import React from 'react';
import SEOHead from '../components/SEOHead';
import './About.css';

const About = () => {
  return (
    <>
      <SEOHead 
        title="About YT DOWN - Free YouTube & TikTok Video Downloader | Our Story"
        description="Learn about YT DOWN, the best free online YouTube and TikTok video downloader. Download HD videos without watermarks. Fast, secure, no registration required. Available on all devices."
        keywords="about yt down, youtube downloader, tiktok downloader, free video downloader, download youtube videos, download tiktok videos, no watermark, hd video download, online video downloader"
        url="https://digimac.pro/about"
      />
      <section id="about" className="about-section">
      <div className="about-container">
        {/* Hero Section */}
        <div className="about-hero">
          <h1 className="about-title">About YT DOWN</h1>
          <p className="about-subtitle">
            Your Trusted Free YouTube & TikTok Video Downloader
          </p>
        </div>

        {/* Introduction */}
        <div className="about-content">
          <div className="content-block">
            <h2>Welcome to YT DOWN</h2>
            <p>
              YT DOWN is a free online video downloader platform designed to help you download 
              YouTube and TikTok videos quickly, safely, and in high quality. Our mission is to 
              provide a simple, fast, and secure way to save your favorite videos from YouTube 
              and TikTok without any hassle, registration, or software installation.
            </p>
            <p>
              Whether you want to download YouTube videos in HD quality or save TikTok videos 
              without watermarks, YT DOWN offers the perfect solution. Our platform is built 
              with user experience in mind, ensuring that anyone can download videos with just 
              a few clicks.
            </p>
          </div>

          {/* What We Offer */}
          <div className="content-block">
            <h2>What We Offer</h2>
            <p>
              YT DOWN is more than just a video downloader – it's a comprehensive platform that 
              combines speed, security, and simplicity. Here's what makes us the best choice for 
              downloading YouTube and TikTok videos:
            </p>
          </div>

          {/* Features Grid */}
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">🎬</div>
              <h3>YouTube Video Downloader</h3>
              <p>
                Download YouTube videos in HD quality with our fast and reliable YouTube video 
                downloader. Save videos in MP4 format or extract audio in MP3 format. Support 
                for all video qualities including 720p, 1080p, and higher resolutions.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🎵</div>
              <h3>TikTok Video Downloader</h3>
              <p>
                Download TikTok videos without watermark using our advanced TikTok downloader. 
                Save clean, high-quality TikTok videos in MP4 format without the TikTok logo. 
                Perfect for content creators and video enthusiasts.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">⚡</div>
              <h3>Fast & Secure Downloads</h3>
              <p>
                Experience lightning-fast download speeds with our optimized servers. Your 
                downloads are processed securely, and we never store your personal information 
                or downloaded videos. Complete privacy guaranteed.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🆓</div>
              <h3>100% Free to Use</h3>
              <p>
                Download unlimited YouTube and TikTok videos completely free. No hidden charges, 
                no subscription fees, no premium plans. All features are available to everyone 
                at no cost.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🎯</div>
              <h3>No Watermark Downloads</h3>
              <p>
                Remove TikTok watermarks automatically. Download clean videos without any logos 
                or watermarks. Perfect for reposting, editing, or personal collection.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">📱</div>
              <h3>All Devices Supported</h3>
              <p>
                Works seamlessly on all devices including Windows, Mac, Android, iPhone, iPad, 
                and tablets. Compatible with all modern browsers including Chrome, Firefox, 
                Safari, and Edge.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🔒</div>
              <h3>Safe & Privacy-Friendly</h3>
              <p>
                Your privacy is our priority. We don't collect personal data, track your 
                downloads, or store any videos. All downloads are processed securely with 
                SSL encryption.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">✨</div>
              <h3>No Software Installation</h3>
              <p>
                Use our online video downloader directly in your browser. No need to download 
                or install any software, apps, or browser extensions. Just paste the URL and 
                download.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🎨</div>
              <h3>HD Quality Downloads</h3>
              <p>
                Download videos in the highest quality available. Support for HD, Full HD, and 
                even 4K resolution videos. Choose your preferred quality before downloading.
              </p>
            </div>
          </div>

          {/* How It Works */}
          <div className="content-block">
            <h2>How YT DOWN Works</h2>
            <p>
              Downloading videos from YouTube and TikTok has never been easier. Our simple 
              three-step process ensures that anyone can download videos in seconds:
            </p>
            
            <div className="steps-list">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4>Copy Video URL</h4>
                  <p>
                    Open YouTube or TikTok app, find the video you want to download, tap the 
                    Share button, and copy the video link to your clipboard.
                  </p>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4>Paste URL in YT DOWN</h4>
                  <p>
                    Visit YT DOWN website, paste the copied video URL into the input field at 
                    the top of the page, and click the Download button.
                  </p>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4>Download Your Video</h4>
                  <p>
                    Choose your preferred format (MP4 video or MP3 audio) and quality. Click 
                    the download button and save the video to your device instantly.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="content-block">
            <h2>Why Choose YT DOWN?</h2>
            <p>
              With countless video downloader websites available, here's why YT DOWN stands out 
              as the best choice for downloading YouTube and TikTok videos:
            </p>

            <ul className="benefits-list">
              <li>
                <strong>Completely Free:</strong> No hidden costs, no premium features locked 
                behind paywalls. Everything is free forever.
              </li>
              <li>
                <strong>No Registration Required:</strong> Start downloading immediately without 
                creating an account or providing personal information.
              </li>
              <li>
                <strong>Unlimited Downloads:</strong> Download as many videos as you want. No 
                daily limits or restrictions.
              </li>
              <li>
                <strong>High-Speed Servers:</strong> Our optimized servers ensure fast download 
                speeds, even for large HD videos.
              </li>
              <li>
                <strong>No Watermarks:</strong> Download TikTok videos without watermarks for 
                clean, professional-looking content.
              </li>
              <li>
                <strong>Multiple Formats:</strong> Save videos in MP4 format or extract audio 
                in MP3 format based on your needs.
              </li>
              <li>
                <strong>Cross-Platform:</strong> Works on all devices and operating systems 
                without any compatibility issues.
              </li>
              <li>
                <strong>Regular Updates:</strong> We continuously improve our service to ensure 
                compatibility with the latest YouTube and TikTok updates.
              </li>
              <li>
                <strong>User-Friendly Interface:</strong> Clean, modern design that's easy to 
                navigate for users of all technical levels.
              </li>
              <li>
                <strong>24/7 Availability:</strong> Download videos anytime, anywhere. Our 
                service is always online and ready to use.
              </li>
            </ul>
          </div>

          {/* Our Commitment */}
          <div className="content-block">
            <h2>Our Commitment to You</h2>
            <p>
              At YT DOWN, we are committed to providing the best free online video downloader 
              experience. We understand the importance of having quick access to your favorite 
              videos, whether for offline viewing, content creation, or personal archiving.
            </p>
            <p>
              We continuously work to improve our platform, ensuring fast download speeds, 
              maximum compatibility, and the highest quality downloads. Your satisfaction and 
              privacy are our top priorities.
            </p>
          </div>

          {/* Legal & Ethical Use */}
          <div className="content-block">
            <h2>Legal & Ethical Use</h2>
            <p>
              YT DOWN is designed to help users download videos for personal, offline viewing. 
              We encourage all users to respect copyright laws and content creators' rights. 
              Please ensure you have the necessary permissions before downloading and using 
              any content.
            </p>
            <p>
              We are not affiliated with YouTube, TikTok, Google, or ByteDance. YT DOWN is an 
              independent platform that provides video downloading services for personal use only.
            </p>
          </div>

          {/* Get Started */}
          <div className="content-block cta-block">
            <h2>Start Downloading Today</h2>
            <p>
              Ready to download your favorite YouTube and TikTok videos? Get started now with 
              YT DOWN – the fastest, safest, and most reliable free online video downloader.
            </p>
            <p>
              No registration, no fees, no hassle. Just paste the URL and download!
            </p>
            <a href="/" className="cta-button">Start Downloading Now</a>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default About;
